<template>
    <div class="countdown">
        {{date}}
    </div>
</template>
<script>
export default {
    data () {
        return {
            date: ''
        }
    },
    props: {
        timeStamp: ''
    },
    mounted () {
        this.countDown()
    },
    methods: {
        countDown: function () {
            var countDownDate = new Date(this.timeStamp).getTime();
            // console.log(countDownDate)
            var _self = this
            // Update the count down every 1 second
            var x = setInterval(function() {
                // Get today's date and time
                var now = new Date().getTime();

                // Find the distance between now and the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                var days = (Array(2).join(0)+Math.floor(distance / (1000 * 60 * 60 * 24))).slice(-2);
                var hours = (Array(2).join(0)+Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).slice(-2);
                var minutes = (Array(2).join(0)+Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
                var seconds = (Array(2).join(0)+Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);
                _self.date = (days*24)+parseInt(hours)+" : "+minutes+" : "+seconds
              
                // If the count down is finished, write some text
                if (distance < 0) {
                    clearInterval(x);
                    _self.date = "00 : 00 : 00"
                }
            }, 1000);
        }
    }
}
</script>
<style lang="scss"  >
    .countdown{
        color: #fff;
        font-weight: 300;
        margin-left: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/components/widge/CountDown.vue